import React from "react";

// Lista completă de județe (diacritice păstrate)
export const JUDETE = [
  "Alba","Arad","Argeș","Bacău","Bihor","Bistrița-Năsăud","Botoșani","Brașov","Brăila","București","Buzău","Caraș-Severin","Călărași","Cluj","Constanța","Covasna","Dâmbovița","Dolj","Galați","Giurgiu","Gorj","Harghita","Hunedoara","Ialomița","Iași","Ilfov","Maramureș","Mehedinți","Mureș","Neamț","Olt","Prahova","Sălaj","Satu Mare","Sibiu","Suceava","Teleorman","Timiș","Tulcea","Vâlcea","Vaslui","Vrancea"
];

/**
 * Select pentru județ – controlat
 */
export default function SelectJudet({
  value = "",
  onChange = () => {},
  required = true,
  label = "Selectați județul",
  id = "judet",
  error = null,
  className = "",
  disabled = false,
  placeholder = "— alegeți județul —",
  helpText = "Folosim județul pentru calcul logistic și ofertare.",
}) {
  const safeValue = typeof value === "string" ? value : "";

  const showCustom = safeValue && !JUDETE.includes(safeValue);

  return (
    <div className={"cfg-field " + className}>
      <label htmlFor={id} className="cfg-label">{label}</label>

      <select
        id={id}
        name={id}
        value={safeValue || ""}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        disabled={disabled}
        className={`cfg-select ${error ? "cfg-select--error" : ""}`}
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : undefined}
        autoComplete="address-level1"
      >
        <option value="" disabled>
          {placeholder}
        </option>

        {showCustom && (
          <option value={safeValue}>{safeValue}</option>
        )}

        {JUDETE.map((j) => (
          <option key={j} value={j}>{j}</option>
        ))}
      </select>

      {error ? (
        <span id={`${id}-error`} className="cfg-error">{error}</span>
      ) : (
        helpText ? <p className="cfg-help">{helpText}</p> : null
      )}
    </div>
  );
}

export function getJudete() {
  return [...JUDETE];
}
